<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.25 14.37">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="CmOFgz.tif">
          <g id="Group_1079" data-name="Group 1079">
            <path
              id="Path_410"
              data-name="Path 410"
              class="cls-1"
              d="M12.4,0a3.47,3.47,0,0,0,.34.42l4,3.9a5.43,5.43,0,0,0,.46.35L12.32,9.42v-3H6.59V3.1H12.3V0Z"
            />
            <path
              id="Path_411"
              data-name="Path 411"
              class="cls-1"
              d="M4.82,14.37A4.18,4.18,0,0,0,4.48,14L.43,10.05C.31,9.93.18,9.82,0,9.67L4.9,5V8h5.73v3.27H4.93v3.1Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
